//Whoever releases the SDK has to update the version number
const sdkVersion = "1.21.3.17";

export { sdkVersion }